import React from 'react';
const stats = [{
  label: 'Clients served',
  value: '50',
  suffix: '+'
}, {
  label: 'Projects shipped',
  value: '500',
  suffix: '+'
}, {
  label: 'Years in Nairobi',
  value: '5',
  suffix: '+'
}, {
  label: 'People on the team',
  value: '7',
  suffix: ''
}];
export function Stats() {
  return <section className="sec" data-id="element-235">
      <div className="sec__head" data-id="element-236">
        <h2 data-id="element-237">Yetu is your perfect choice</h2>
        <p data-id="element-238">
          Small enough to care about every pixel, sharp enough to ship work that
          pulls its weight.
        </p>
      </div>

      <div className="stats" data-id="element-239">
        {stats.map((stat, index) => <div key={index} className="stat" data-id="element-240">
            <div className="n" data-id="element-241">
              {stat.value}
              <em data-id="element-242">{stat.suffix}</em>
            </div>
            <div className="l" data-id="element-243">{stat.label}</div>
          </div>)}
      </div>
    </section>;
}